import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'flow-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})
export class TabComponent implements OnInit {

  @Input() tab = '';
  @Input() title = '';
  @Input() active = false;
  @Input() disabled = false;

  constructor() { }

  ngOnInit() {
  }

}
